import { Similar } from './similar';
import type { Template } from '~/api/interface';
import RightArrow from '~/assets/svg/arrow-white.svg?url';
import Resource from '~/components/resource';
import VideoPlayer from '~/components/video-player/index.vue';

export const getOtherList = (list: any[], active: any) => {
  let before: any = [];
  let after: any = [];

  const index = list?.findIndex((x: any) => x.id === active?.id);
  // 数据排序
  if (index >= 1) {
    before = list.slice(index - 1, index);
    after = list.slice(index + 1, list.length).concat(list.slice(0, index - 1));
  } else {
    before = list.slice(1, list.length);
  }
  return before.concat(after);
};

export const TemplateDetail = defineComponent({
  setup() {
    const { $t } = useNuxtApp();
    const classInfo = useClassState();
    const dataList = ref<Template[]>(classInfo.value.list || []);
    const activeIndex = computed(() => {
      if (!classInfo.value.active) {
        return -1;
      }
      const index = dataList.value?.findIndex(x => x.id === classInfo.value.active?.id);
      return index;
    });

    const next = (type: 1 | -1) => {
      classInfo.value.active = dataList.value[activeIndex.value + type];
    };

    const onSimilarClick = (list: Template[], data: Template) => {
      classInfo.value.active = data;
    };

    const otherList = computed(() => getOtherList(dataList.value, classInfo.value.active));
    return () => (
      <div class="p-[24px]">
        <div class="w-full h-[479.25px] object-fill rounded-[12px] bg-back-1 overflow-hidden">
          <VideoPlayer
            url={classInfo.value.active?.full_video_url}
            auto-url={classInfo.value.active?.preview_m3u8_url}
            class="w-full h-full object-fill !rounded-[12px] overflow-hidden"
            style="box-shadow: 0px 7px 36px 0px rgba(0, 0, 0, 0.1)"
            id={classInfo.value.active?.id}
          />
        </div>
        <div>
          <div class="truncate text-[16px] mt-[10px] text-font-1 font-bold">
            {classInfo.value.active?.title}
          </div>
          <div class="mt-[10px]">
            <div class="flex-y-center gap-[6px]">
              <Resource
                class="border-[1px] border-solid border-back-4 w-[16px] h-[16px] rounded-[50%]"
                src={classInfo.value.active?.logo_url}
                transformResource={transformImage}
              />
              <span class="text-12 text-font-40">{classInfo.value.active?.team_name}</span>
            </div>
          </div>
          <a-divider class="my-[16px]"></a-divider>
          <div class="leading-[18px] text-[12px] text-font-70">
            {classInfo.value.active?.description}
          </div>
        </div>
        <div class="mt-[20px]">
          <Similar
            title={$t('wei-wo-tui-jian')}
            active={classInfo.value.active}
            list={otherList.value}
            onSimilarClick={onSimilarClick}
          />
        </div>
        {activeIndex.value > 0 && (
          <div
            class="absolute -left-[60px] top-[50%] w-[50px] h-[50px] rounded-full bg-[rgba(235,235,235,0)]  cursor-pointer hover:bg-[rgba(235,235,235,0.2)] flex-y-center justify-center"
            onClick={() => next(-1)}
          >
            <Resource src={RightArrow} class="w-[26px] h-[26px] rotate-180 mr-[5px]" />
          </div>
        )}
        {activeIndex.value < dataList.value?.length - 1 && (
          <div
            onClick={() => next(1)}
            class=" w-[50px] h-[50px] rounded-full bg-[rgba(235,235,235,0)] cursor-pointer hover:bg-[rgba(235,235,235,0.2)]  absolute top-[50%] text-white text-[30px] right-[-60px] flex-y-center justify-center"
          >
            <Resource src={RightArrow} class="w-[26px] h-[26px] ml-[5px]" />
          </div>
        )}
      </div>
    );
  },
});
